import classNames from 'classnames/bind';
import React from 'react';
import { FaMapMarker } from 'react-icons/fa';
import { RiFlightTakeoffLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';

import styles from './AddTakeoff.module.scss';

import actions from '@/actions';
import { PrimaryButton } from '@/components/ui/kit/Button';
import ModalWrapper from '@/components/ui/ModalWrapper';
import { modalManager } from '@/libs/ModalContainer';
import { getCSSVariable } from '@/utils/theme';

const cx = classNames.bind(styles);

const Modal = () => {
  const dispatch = useDispatch();

  const doStart = () => {
    dispatch(actions.editor.changeMode('path/point'));
    modalManager.hide();
  };

  return (
    <ModalWrapper disableEscape className={cx('container')}>
      <div className={cx('icon')}>
        <div className={cx('marker')}>
          <FaMapMarker size={40} color={getCSSVariable('--tint-color')} />
          <div className={cx('label')}>
            <RiFlightTakeoffLine size={16} color="white" />
          </div>
        </div>
        <div className={cx('plate')} />
      </div>
      <div className={cx('message')}>Add a takeoff point.</div>
      <PrimaryButton text="Start" accent center onClick={doStart} />
    </ModalWrapper>
  );
};

export default Modal;
